import i18next from "i18next";
import { useGetCurrentVendor } from "./User";

export const useGetAvailableTranslation = () => {
  return ["SL", "EN", "HR", "DE", "SR"]; //"AL", "BA", "ME", "MK"
};

export const useGetAvailableTranslationLong = () => {
  const languageMap = {
    SL: "Slovenian",
    EN: "English",
    HR: "Croatian",
    DE: "German",
    SR: "Serbian",
    AL: "Albanian",
    BA: "Bosnian",
    ME: "Montenegrin",
    MK: "Macedonian"
  };

  return useGetAvailableTranslation().map(code => ({
    code,
    name: languageMap[code] || code
  }));
};


export const useGetAvailableLanguages = () => {
  const vendor = useGetCurrentVendor();
  const availableLanguages = useGetAvailableTranslation();

  if (!vendor.languages) {
    return ["SL"];
  }
  const intersectedLanguages = vendor.languages.filter(language => availableLanguages.includes(language));
  return intersectedLanguages.length > 0 ? intersectedLanguages : ["SL"];
};


export function getLanguagesInputValue(value, availableLan, isAnswer) {
  let result;

  if (Array.isArray(value)) {
    result = [];
    value.forEach((e) => {
      let temp = {};
      availableLan.forEach((lng) => {
        temp[lng] = e[lng] || "";
      });
      result.push(temp);
    });
  } else {
    let initialValue = {};
    availableLan.forEach((lng) => {
      initialValue[lng] = value !== null && value[lng] ? value[lng] : "";
    });
    result = initialValue;
  }

  return isAnswer && !Array.isArray(value) ? [result] : result;
}



export function useGetAllTranslationsForKey() {
  const translations = {};
  const availableLanguages = useGetAvailableTranslation();

  const getTranslationObject = (key) => {

    availableLanguages.forEach(lang => {
      const translation = i18next.t(key, { lng: lang });
      translations[lang.toUpperCase()] = translation;
    });

    return translations;
  }
  return {getTranslationObject};
}


/**
 * Selects the appropriate text for a given language, falling back through a list of available languages in order.
 * If no suitable text is found, a default message is returned.
 */
export function selectTextByLanguage(texts, preferredLang, availableLanguages) {

  if (typeof texts === 'object') {
    // First try the preferred language
    if (texts[preferredLang]) {
      return texts[preferredLang];
    }

    for (const lang of availableLanguages) {
      if (texts[lang]) {
        return texts[lang];
      }
    }
  } else {
    return texts;
  }


  // If no available languages have text, return the default message
  return "NO TEXT FOUND";
}

/**
 * Selects the appropriate text for a given language, falling back through a list of available languages in order.
 * If no suitable text is found, a default message is returned.
 */
export function useSelectLanguage() {

  let preferredLang = i18next.language;
  const availableLanguages = useGetAvailableTranslation()


  const selectTextByLanguage = (texts, lng = null) => {

    if (lng) preferredLang = lng;

    if (typeof texts === 'object' && texts !== null) {
      // First try the preferred language
      if (texts[preferredLang]) {
        return texts[preferredLang];
      }

      for (const lang of availableLanguages) {
        if (texts[lang]) {
          return texts[lang];
        }
      }
    } else {
      return texts;
    }

    // If no available languages have text, return the default message
    return "";

  }

  return { selectTextByLanguage, preferredLang, availableLanguages };

}